import Pages from '@opsbase/lib-pages';
import i18n from '@opsbase/lib-i18n';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import DVLPage from '@opsbase/web-dvl-page';
import Vertical from '@opsbase/web-layout/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import React from 'react';
import OpsSelectionToolbar from '../../toolbars/OpsSelectionToolbar';
export const OpsAnalyseDialog = function () {
    let { viewId } = useParams();
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL },
        React.createElement(Vertical, { style: { overflow: 'hidden' } },
            React.createElement(DVLPage, { key: "opslog", padding: "4px 16px", viewId: viewId, itemPage: Pages.OP_VIEW, itemDeletePage: Pages.OP_DELETE, notFoundText: i18n.t('no-ops-found'), itemSelectionToolbar: React.createElement(OpsSelectionToolbar, null) }))));
};
export default OpsAnalyseDialog;
